// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__+2R3e","subBox":"Toast_subBox__EEE-Y","words":"Toast_words__pBxki","close":"Toast_close__3C7tM"};